import { gql } from "@apollo/client";

export default gql`
    mutation DeleteDocument($deleteDocumentId: Float!) {
        deleteDocument(id: $deleteDocumentId)
    }
`;
